import { render, staticRenderFns } from "./BeautyScheduleActions.vue?vue&type=template&id=ed2dda10&scoped=true"
import script from "./BeautyScheduleActions.vue?vue&type=script&lang=js"
export * from "./BeautyScheduleActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2dda10",
  null
  
)

export default component.exports